<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Coltan, Congo’s Curse</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/Text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/Text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/Text/ch003#copyright-information">Copyright Information</a></li>
<li id="toc-li-4"><a href="#/Text/ch004#acknowledgements">Acknowledgements</a></li>
<li id="toc-li-5"><a href="#/Text/ch005#disclaimer">Disclaimer</a></li>
<li id="toc-li-6"><a href="#/Text/ch006#april-07-1994">April 07, 1994</a></li>
<li id="toc-li-7"><a href="#/Text/ch007#prologue">Prologue</a></li>
<li id="toc-li-8"><a href="#/Text/ch008#chapter-1-natural-resources">Chapter 1: Natural Resources</a></li>
<li id="toc-li-9"><a href="#/Text/ch009#chapter-2-old-friends">Chapter 2: Old Friends</a></li>
<li id="toc-li-10"><span href="#/Text/ch010#chapter-3-memories" title="Link target outside of Sample">Chapter 3: Memories</span></li>
<li id="toc-li-11"><span href="#/Text/ch011#chapter-4-shopping" title="Link target outside of Sample">Chapter 4: Shopping</span></li>
<li id="toc-li-12"><span href="#/Text/ch012#chapter-5-going-back" title="Link target outside of Sample">Chapter 5: Going Back</span></li>
<li id="toc-li-13"><span href="#/Text/ch013#chapter-6-perilous-moves" title="Link target outside of Sample">Chapter 6: Perilous Moves</span></li>
<li id="toc-li-14"><span href="#/Text/ch014#chapter-7-the-shit-hits-the-fan" title="Link target outside of Sample">Chapter 7: The Shit Hits the Fan</span></li>
<li id="toc-li-15"><span href="#/Text/ch015#chapter-8-the-real-game-begins" title="Link target outside of Sample">Chapter 8: The Real Game Begins</span></li>
<li id="toc-li-16"><span href="#/Text/ch016#chapter-9-check.-the-king-needs-to-make-a-move" title="Link target outside of Sample">Chapter 9: Check. The King Needs to Make a Move</span></li>
<li id="toc-li-17"><span href="#/Text/ch017#chapter-10-do-horses-jump" title="Link target outside of Sample">Chapter 10: Do Horses Jump?</span></li>
<li id="toc-li-18"><span href="#/Text/ch018#chapter-11-check-again.-the-king-stumbles" title="Link target outside of Sample">Chapter 11: Check Again. The King Stumbles</span></li>
<li id="toc-li-19"><span href="#/Text/ch019#chapter-12-anxious-moves-of-a-king" title="Link target outside of Sample">Chapter 12: Anxious Moves of a King</span></li>
<li id="toc-li-20"><span href="#/Text/ch020#chapter-13-moves-of-a-queen" title="Link target outside of Sample">Chapter 13: Moves of a Queen</span></li>
<li id="toc-li-21"><span href="#/Text/ch021#chapter-14-a-last-pawn" title="Link target outside of Sample">Chapter 14: A Last Pawn</span></li>
<li id="toc-li-22"><span href="#/Text/ch022#chapter-15-reshuffling-the-game" title="Link target outside of Sample">Chapter 15: Reshuffling the Game</span></li>
<li id="toc-li-23"><span href="#/Text/ch023#chapter-16-explanations" title="Link target outside of Sample">Chapter 16: Explanations</span></li>
<li id="toc-li-24"><span href="#/Text/ch024#chapter-17-endgame" title="Link target outside of Sample">Chapter 17: Endgame?</span></li>
<li id="toc-li-25"><span href="#/Text/ch025#chapter-18-davos" title="Link target outside of Sample">Chapter 18: Davos</span></li>
<li id="toc-li-26"><span href="#/Text/ch026#chapter-19-home-at-last" title="Link target outside of Sample">Chapter 19: Home, at Last</span></li>
<li id="toc-li-27"><span href="#/Text/ch027#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?d7da1da2